import React from 'react';

import { CardButton } from './QuizOptionCard.styled';
import { Heading } from 'components/v2/Typography/Heading';

interface Props {
  mainText: string;
  selected?: boolean;
  onClick: () => void;
}

export const QuizOptionCard = ({ mainText, selected, onClick }: Props): JSX.Element => (
  <CardButton $selected={selected} onClick={onClick} type="button">
    <Heading tag="h3" styledAs="h3" noMargin>
      {mainText}
    </Heading>
  </CardButton>
);
